import React, { useState } from 'react'
import { HistorialSolicitudesHorasExtras, ResponseHistoriaHE } from '../SolicitudPagoHE/TypesSolicitudPagoHE'
import { Container, Row, Col } from "reactstrap"
import { KeyValuePair } from 'components/Types/GeneralTypes'
import CardHistoriaSolicitudHE from './CardHistoriaSolicitudHE'
import { ObtenerFechaFromIsoFormat } from 'functions/DatesFunctions'
import "../../../../assets/scss/Horas Extras/HistoriaSolicitudServidor.scss"

import PdfSVG from "assets/icons/Permisos/PDF(azul).svg"

import ModalVistaPreviaDocumentos from 'components/Varios/Modals/ModalVistaPreviaDocumentos'
import { VistaPreviaSolicitudHEIngresada } from '../SolicitudPagoHE/FunctionsSolicitudPagoHE'
import { showAlert } from 'components/Admin/Horas Extras/Parametros Horas Extras/Actividades/ActividadesHorasExtras'
import { GetDocumentVistaPrevia2 } from 'helpers/files'
import { useHistory } from 'react-router'

import EditarSVG from "assets/icons/Permisos/editarAzul.svg"
import ModalConfirmacion from 'components/Varios/Modals/ModalConfirmacion'


type HistorialSolicitudes = {
    historia: ResponseHistoriaHE
}


export function PrimeraLetraMayuscula(texto: string) {
    return `${texto.charAt(0).toUpperCase() + texto.slice(1)}`
}

export default function HistorialSolicitudes(props: HistorialSolicitudes) {

    const [urlDocumentoVP, seturlDocumentoVP] = useState<string>("")
    const [loading, setloading] = useState<boolean>(false)
    const [loadingHojaMarcacion, setloadingHojaMarcacion] = useState<boolean>(false)
    const [urlHojaMarcacionVP, seturlHojaMarcacionVP] = useState<string>("")
    const [nombreUnidad, setnombreUnidad] = useState<string>("")
    const history = useHistory();

    async function GenerarVistaPreviaSolicitudHE(idSolicitudHE: number) {
        setloading(true)

        const respuestaVistaPrevia = await VistaPreviaSolicitudHEIngresada(idSolicitudHE);

        if (respuestaVistaPrevia.status === 200 && respuestaVistaPrevia.dataResponse) {
            seturlDocumentoVP(respuestaVistaPrevia.dataResponse)
        }
        else {
            showAlert("No es posible cargar la vista previa del documento", false);
        }


        setloading(false)
    }


    async function OnClickDocumento(historia: HistorialSolicitudesHorasExtras) {
        if (historia.refarchivo) {
            setloading(true)
            const url = await GetDocumentVistaPrevia2(historia.refarchivo)
            if (url) {
                seturlDocumentoVP(url)
            }
            setloading(false)
        }
        else {
            await GenerarVistaPreviaSolicitudHE(historia.idSolicitud)
        }
    }

    async function OnClickDocumentoHojaMarcacion(refArchivo: string) {
        if (refArchivo) {
            setloadingHojaMarcacion(true)
            const url = await GetDocumentVistaPrevia2(refArchivo)
            if (url) {
                seturlHojaMarcacionVP(url)
            }
            setloadingHojaMarcacion(false)
        }
        else {
            showAlert("Referencia de archivo no válida", false)
        }
    }

    return (
        <>
            <Container fluid>
                {
                    props.historia.solicitudesIngresadas.length > 0 &&
                    <>
                        <h5 className="mt-5">SOLICITUDES INGRESADAS</h5>
                        <Row className="mb-3">
                            <Col xl={5} sm={12} md={8} lg={8} >
                                <div className="table-container">
                                    <table id={"HistoriaSHE"}>
                                        <thead>
                                            <tr>
                                                <th>Fecha de solicitud</th>
                                                <th>Mes</th>
                                                <th>Unidad</th>
                                                <th>Estado</th>
                                                <th className="thPdfHistoriaHE">
                                                    Acciones
                                                </th>
                                                <th>
                                                    Observaciones
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                props.historia.solicitudesIngresadas.map((v, i) => {
                                                    const mesDescripcion = PrimeraLetraMayuscula(v.mesDescripcion)
                                                    return (
                                                        <tr>
                                                            <td> {ObtenerFechaFromIsoFormat(v.fechaSolicitud)}  </td>
                                                            <td> {mesDescripcion} </td>
                                                            <td key={v.siglasUnidad + " descripcionHistoriaHE"}
                                                                className="tdSiglasUnidadHistoriaHE"
                                                                data-toggle="tooltip" data-placement="top" title={v.unidad}
                                                                onClick={() => setnombreUnidad(v.unidad)}
                                                            >
                                                                {v.siglasUnidad}
                                                            </td>
                                                            <td> {v.estadoDescripcionHistoria} </td>
                                                            <td>
                                                                <div>
                                                                    {
                                                                        ["GU", "NT", "ND"].includes(v.estado) &&
                                                                        <img
                                                                            src={EditarSVG}
                                                                            className='iconPDF'
                                                                            alt={`Editar Solicitud de Pago de HE del mes de ${mesDescripcion}`}
                                                                            data-toggle="tooltip"
                                                                            data-placement="top"
                                                                            title={`Editar Solicitud de Pago de HE del mes de ${mesDescripcion}`}
                                                                            style={{ width: 19, height: 20 }} // Ajusta el tamaño según necesites
                                                                            onClick={() => {
                                                                                history.push({
                                                                                    pathname: '/web/solicitud_pago_horas_extras/',
                                                                                    state: { anio: v.anio, mes: v.mes }
                                                                                });
                                                                            }}

                                                                        />
                                                                    }
                                                                    {
                                                                        !["GU", "NT", "ND"].includes(v.estado) &&
                                                                        <img
                                                                            src={PdfSVG} // Cambia la ruta al lugar donde esté almacenado tu SVG
                                                                            className="iconPDF"
                                                                            alt={`Solicitud de Pago de HE del mes de ${mesDescripcion}`}
                                                                            data-toggle="tooltip"
                                                                            data-placement="top"
                                                                            title={`Solicitud de Pago de HE del mes de ${mesDescripcion}`}
                                                                            style={{ width: 24, height: 24 }} // Ajusta el tamaño según necesites
                                                                            onClick={() => { OnClickDocumento(v) }}
                                                                        />
                                                                    }
                                                                    <img
                                                                        src={PdfSVG} // Cambia la ruta al lugar donde esté almacenado tu SVG
                                                                        className="iconPDF"
                                                                        alt={`Hoja de marcaciones del mes de ${mesDescripcion}`}
                                                                        data-toggle="tooltip"
                                                                        data-placement="top"
                                                                        title={`Hoja de marcaciones del mes de ${mesDescripcion}`}
                                                                        style={{ width: 24, height: 24 }} // Ajusta el tamaño según necesites
                                                                        onClick={() => { OnClickDocumentoHojaMarcacion(v.refarchivoHojaMarcacion) }}
                                                                    />
                                                                </div>


                                                            </td>
                                                            <td>
                                                                {["ND", "NT"].includes(v.estado.trim()) ?
                                                                    <span> {v.motivoNegado} </span>
                                                                    :
                                                                    <span></span>
                                                                }
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }

                                        </tbody>
                                    </table>
                                </div>

                            </Col>
                        </Row>

                    </>

                }


                <h5>HISTORIAL DE SOLICITUDES</h5>
                <Row>
                    {props.historia.historia.map((v, i) => {
                        if (v.value.length > 0) {
                            return (
                                <Col key={`ColHistorialSHE ${i}`} xs={12} sm={6} md={6} lg={6} xl={4}>
                                    <CardHistoriaSolicitudHE
                                        anio={v.key}
                                        historiaAnio={v.value}
                                        indice={i}
                                        onClickDocumento={async (historia: HistorialSolicitudesHorasExtras) => { OnClickDocumento(historia) }}
                                    />
                                </Col>
                            )
                        }

                    })}

                </Row>
            </Container>
            <ModalVistaPreviaDocumentos
                show={loading || urlDocumentoVP !== ""}
                cargandoDatos={loading}
                size='xl'
                tituloModal='Solicitud de Horas Extras'
                onClose={() => seturlDocumentoVP("")}
                urlArchivo={urlDocumentoVP}
                allHeight={true}
            />
            <ModalVistaPreviaDocumentos
                show={loadingHojaMarcacion || urlHojaMarcacionVP !== ""}
                cargandoDatos={loading}
                size='xl'
                tituloModal='Hoja Marcaciones'
                onClose={() => seturlHojaMarcacionVP("")}
                urlArchivo={urlHojaMarcacionVP}
                allHeight={true}
            />
            <ModalConfirmacion
                show={nombreUnidad !== ""}
                onClose={() => setnombreUnidad("")}
                onClick={() => setnombreUnidad("")}
                size={"md"}
                asyncAccion={false}
                asyncClose={false}
                closeAfterAccion={false}
                hideBotonCerrar={true}
                mensajeConfirmacion={nombreUnidad}
                nombreBotonAccion='Aceptar'
                showTituloModal={false}
                centered={true}
            />
        </>
    )
}
